// colors
import { colors } from '../../../../../../packages/colors';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  drawer: {
    '& .drawerBody': {
      backgroundColor: colors.neutral50,
    },
  },
  bodyWhite: {
    '& .drawerBody': {
      backgroundColor: colors.white,
      height: 'calc(100vh - 81px)',
    },
  },
  backBtn: {
    width: 40,
    height: 40,
    minWidth: 40,
    minHeight: 40,
    padding: '18px 12px',
    borderColor: colors.primary300,
    '& svg': {
      color: colors.primary500,
      width: 18,
      height: 15,
    },
  },
  categories: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '20px 16px',
    gap: 24,
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  headerTitle: {
    margin: 0,
  },
  splitLayout: {
    '& .MuiDrawer-paper': {
      width: '35vw !important',
      maxWidth: '35vw !important',
      left: '30vw !important',
    },
    '& .MuiBackdrop-root': {
      width: '50vw !important',
      right: 'auto !important',
    },
    '& .drawerBody': {
      width: '100%',
      maxWidth: 'none',
    },
  },
  formSection: {
    flex: 1,
    height: '100%',
  },
  formSectionSplit: {
    width: '100%',
    flex: 1,
  },
  externalStepProcess: {
    position: 'fixed',
    top: 0,
    right: 0,
    width: '35vw',
    height: '100vh',
    background: colors.indigo200,
    padding: '16px',
    overflow: 'auto',
    zIndex: 1301,
    pointerEvents: 'auto',
  },
});
